module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h2', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("T​he spinning hum of the roulette wheel was in her ears as the door closed softly behind her. Part of her mind was still upstairs in the casino, listening to the chime of ice in a glass, the clicking of chips on the tables, the hurried rattling of dice in their whirling cages. That memory kept her safe for a moment or two.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She walked along the driveway and through the open gates. She turned left and began to walk down the hill. There was a street lamp at the curb, but its glow was ghostly in the thick fog. Glittering drops of moisture showed already in the satiny sheen of her smooth, pale hair and on her lashes. She blinked quickly, trying to see beyond the shrouding darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The fog pressed down on San Francisco from the Cliff House to the Ferry Building. It lay sluggishly down the length of Market Street. It heaved up until it wrapped around Coit Tower, high above the city. It drained away light and sound and swallowed them in a submarine abyss of empty blackness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was alone now.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She was alone with herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She paused to listen. That was an error. Now there was not even the echo of her high heels tapping hastily on the sloping sidewalk. There was no sound at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She might have been the only one alive in a dead city … a dead world.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The curves of her lips drew tight. She adjusted the strap of her handbag on her shoulder, brushed the fog drops from her lashes, and began to walk again. She walked faster now, but with a certain wariness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She had parked her car too far away. There were two more blocks to walk. On her left, now, should be a park, but she could not see it. She could see nothing but the small patch of glistening sidewalk just before her, and the pale, clouded glow of the street lamps. Everything else was lost in the secret, empty folds of the shrouding night.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was a mistake to be alone. It was always a mistake to be alone.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("… Yet something stirred, deep within her, with a strangely guilty delight, as though somehow it saw and welcomed the death that burst through the fog in sudden, exploding violence.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The strong hand drove down and clamped bruisingly on her mouth. Like dancers in a nightmare two figures, writhing together, reeled from the street into the deeper blackness of the park.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The other strong hand rose, gripping something rough and hard. It hammered down.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("There was a sound.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Then there was a silence. And after that came a quick, faint scratching, and a match flared, held low.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("She lay on her back, watching the fog blindly, her lips parted a little. Near her head lay a rock, small enough to fit a hand, large enough to kill with. Its sharp edge glistened.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("On the grass was the handbag where it had fallen. A cigarette lighter had spilled out of it, and as the match died, red light caught and flashed on the initials jeweled on the lighter’s side: E. P.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The jewels flared like fire in the fog.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The match went out.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2184d954","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_chapter01.vue
// module id = 75
// module chunks = 0